var $export=require("./_export");$export($export.S,"Object",{"setPrototypeOf":require("./_set-proto").set});